import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from 'utils/axios';
import axiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const getDashboard = createAsyncThunk('DASHBOARD INFO', async (thunkAPI) => {
  const response = await axios.get(URL.GET_DASHBOARD, thunkAPI);
  return response.data;
});

export const getDashboardV2 = createAsyncThunk('DASHBOARD INFO V2', async (thunkAPI) => {
  const response = await axiosAdmin.get(URL.GET_DASHBOARD_V2, thunkAPI);
  return response.data;
});

export const getTodayBookings = createAsyncThunk('TODAY BOOKINGS', async (data, thunkAPI) => {
  const response = await axiosAdmin.get(
    `${URL.GET_TODAY_BOOKINGS}?page=${data.page}&limit=${data.limit}`,
    thunkAPI
  );
  return response.data;
});

export const getAgencyChartData = createAsyncThunk('GET AGENCY CHART DATA', async (data, thunkAPI) => {
  const response = await axios.get(URL.GET_AGENCY_CHART, thunkAPI);
  return response.data;
});

export const getBookingStats = createAsyncThunk('GET BOOKING STATS', async (data, thunkAPI) => {
  const params = new URLSearchParams();
  if (data?.start_date) params.set('start_date', data.start_date);
  if (data?.end_date) params.set('end_date', data.end_date);
  const response = await axiosAdmin.get(
    `${URL.BOOKING_STATS}?${params.toString()}`,
    thunkAPI
  );
  return response.data;
});

export const getAccountStats = createAsyncThunk('GET ACCOUNT STATS', async (data, thunkAPI) => {
  const params = new URLSearchParams();
  if (data?.start_date) params.set('start_date', data.start_date);
  if (data?.end_date) params.set('end_date', data.end_date);
  const response = await axiosAdmin.get(
    `${URL.ACCOUNT_STATS}?${params.toString()}`,
    thunkAPI
  );
  return response.data;
});
const initialState = {
  isLoading: false,
  isTodayBookingLoading: false,
  isAgencyChartLoading: false,
  isBookingStatsLoading: false,
  isAccountStatsLoading: false,
  dashboard: null,
  todayBookings: null,
  agencyChartData: null,
  dashboardV2: null,
  bookingStats: null,
  accountStats: null,
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: {
    // dashboard info
    [getDashboard.pending]: (state) => {
      state.isLoading = true;
      state.dashboard = null;
    },
    [getDashboard.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.dashboard = action.payload.data;
    },
    [getDashboard.rejected]: (state, action) => {
      state.isLoading = false;
      state.dashboard = null;
      toast.error(action?.payload?.message);
    },

    // dashboard info
    [getDashboardV2.pending]: (state) => {
      state.isLoading = true;
      state.dashboardV2 = null;
    },
    [getDashboardV2.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.dashboardV2 = action.payload.data;
    },
    [getDashboardV2.rejected]: (state, action) => {
      state.isLoading = false;
      state.dashboardV2 = null;
      toast.error(action?.payload?.message);
    },



    // today bookings
    [getTodayBookings.pending]: (state) => {
      state.isTodayBookingLoading = true;
      state.todayBookings = null;
    },
    [getTodayBookings.fulfilled]: (state, action) => {
      state.isTodayBookingLoading = false;
      state.todayBookings = action.payload.data;
    },
    [getTodayBookings.rejected]: (state, action) => {
      state.isTodayBookingLoading = false;
      state.todayBookings = null;
      toast.error(action?.payload?.message);
    },

    // today bookings
    [getAgencyChartData.pending]: (state) => {
      state.isAgencyChartLoading = true;
      state.agencyChartData = null;
    },
    [getAgencyChartData.fulfilled]: (state, action) => {
      state.isAgencyChartLoading = false;
      state.agencyChartData = action.payload.data;
    },
    [getAgencyChartData.rejected]: (state, action) => {
      state.isAgencyChartLoading = false;
      state.agencyChartData = null;
      toast.error(action?.payload?.message);
    },

    [getBookingStats.pending]: (state) => {
      state.isBookingStatsLoading = true;
      state.bookingStats = null;
    },
    [getBookingStats.fulfilled]: (state, action) => {
      state.isBookingStatsLoading = false;
      state.bookingStats = action.payload.data;
    },
    [getBookingStats.rejected]: (state, action) => {
      state.isBookingStatsLoading = false;
      state.bookingStats = null;
      toast.error(action?.payload?.message || 'Failed to fetch booking stats');
    },
    [getAccountStats.pending]: (state) => {
      state.isAccountStatsLoading = true;
      state.accountStats = null;
    },
    [getAccountStats.fulfilled]: (state, action) => {
      state.isAccountStatsLoading = false;
      state.accountStats = action.payload.data;
    },
    [getAccountStats.rejected]: (state, action) => {
      state.isAccountStatsLoading = false;
      state.accountStats = null;
      toast.error(action?.payload?.message);
    },
  },
});

export default dashboardSlice.reducer;
